const CustomFooterLinks = () => null;

export default CustomFooterLinks;
